import {
  CANVAS_CONTAINER_ORIGINAL_HEIGHT_KEY,
  CANVAS_CONTAINER_ORIGINAL_WIDTH_KEY
} from "@frontend/group/modules/canvas-zoom/constants";

export const zoomCanvas = (canvas, scaleFactor) => {

  const newZoom = canvas.getZoom() * scaleFactor;
  const newWidth = canvas.getWidth() * scaleFactor;
  const newHeight = canvas.getHeight() * scaleFactor;

  const $canvasGridStackItem = $(canvas.lowerCanvasEl).parents('.grid-stack-item').first();
  const $canvasContainer = $canvasGridStackItem.find('.canvas-container');

  if (!$canvasContainer.attr(CANVAS_CONTAINER_ORIGINAL_WIDTH_KEY)) {
    $canvasContainer.attr(CANVAS_CONTAINER_ORIGINAL_WIDTH_KEY, $canvasGridStackItem.width());
  }

  if (!$canvasContainer.attr(CANVAS_CONTAINER_ORIGINAL_HEIGHT_KEY)) {
    $canvasContainer.attr(CANVAS_CONTAINER_ORIGINAL_HEIGHT_KEY, $canvasGridStackItem.height());
  }

  canvas.setZoom(newZoom);
  canvas.setWidth(newWidth);
  canvas.setHeight(newHeight);

  $canvasGridStackItem.css({
    height: newHeight + 'px'
  });
};

export const zoomRuler = (ruler, width, height) => {
  ruler.domWidth = width;
  ruler.createHorizontalRuler();
  ruler.domHeight = height;
  ruler.createVerticalRuler();
};
